/**
 * Transcribed from para-node `src/constants/partner-oatfi-business.constants.ts` and
 * `src/constants/oatfi.constants.ts`. Every value is validated with @IsEnum on the wire, so an
 * invented member is a 400, not a silently-ignored value — the admin-prototype's Business view
 * invents several. Do not add a member that is not in those two backend files.
 */
export enum UnderwritingStatus {
  Error = 'ERROR',
  Approved = 'APPROVED',
  ManualReview = 'MANUAL_REVIEW',
  Processing = 'PROCESSING',
  Declined = 'DECLINED',
}

export enum BusinessEntityType {
  Llc = 'LLC',
  SoleProprietor = 'SOLE_PROPRIETOR',
  Partnership = 'PARTNERSHIP',
  Corporation = 'CORPORATION',
  Cooperative = 'COOPERATIVE',
  NonProfit = 'NON_PROFIT',
  NotSure = 'NOT_SURE',
  NotRegisteredYet = 'NOT_REGISTERED_YET',
  Trusts = 'TRUSTS',
  UnincorporatedAssociations = 'UNINCORPORATED_ASSOCIATIONS',
}

/**
 * The one enum here whose wire values are capitalised words rather than SCREAMING_CASE. These
 * are wire values: `Partner` must NOT be renamed to `Customer` by the customer-terminology rule
 * or the request becomes an invalid enum. Only the labels change — see LIMIT_SOURCE_LABELS.
 */
export enum RequestedLimitSource {
  Partner = 'Partner',
  Customer = 'Customer',
}

export enum SupplementalDataType {
  BankStatements = 'BANK_STATEMENTS',
  AccountingData = 'ACCOUNTING_DATA',
  BalanceSheet = 'BALANCE_SHEET',
  ProfitLoss = 'PROFIT_LOSS',
  Invoice = 'INVOICE',
  TermsDoc = 'TERMS_DOC',
}
